// ===== LYNXCLE MINI VERIFIER — JAVASCRIPT PART =====
(function(){
  // ---------- helpers ----------
  function $id(x){ return document.getElementById(x); }
  function toNum(v, d){ var n=parseFloat(v); return isFinite(n)?n:d; }

  // ---------- physics ----------
  var RHO=1.225, G=9.81;
  function powerRequired(v_mps, m, grade_pct, Crr, CdA, wind_mps){
    var v_air = Math.max(0, v_mps + wind_mps);
    var F_roll = Crr * m * G;
    var F_grav = m * G * (grade_pct/100);
    var F_drag = 0.5 * RHO * CdA * v_air * v_air;
    return v_mps * (F_roll + F_grav + F_drag);
  }
  function mechAvailable(V, I, drive){
    var eff_motor = (drive==='mid')?0.88:0.82;
    var eff_ctrl  = 0.97;
    var eff_drive = (drive==='mid')?0.95:1.00;
    return V * I * eff_motor * eff_ctrl * eff_drive;
  }
  function solveVmax(Pavail, m, grade, Crr, CdA, wind){
    var lo=0.1, hi=40, i, mid, P;
    for(i=0;i<42;i++){
      mid=(lo+hi)/2;
      P=powerRequired(mid, m, grade, Crr, CdA, wind);
      if(P<=Pavail) lo=mid; else hi=mid;
    }
    return lo;
  }

  // ---------- actions ----------
  function runSim(){
    var drive = ($id('sim_drive')||{}).value || 'hub';
    var V     = toNum(($id('sim_v')||{}).value, 48);
    var I     = toNum(($id('sim_i')||{}).value, 20);
    var Pcont = toNum(($id('sim_pcont')||{}).value, 500);
    var grade = toNum(($id('sim_grade')||{}).value, 6);
    var speed = toNum(($id('sim_speed')||{}).value, 25);
    var mass  = toNum(($id('sim_mass')||{}).value, 100);
    var pos   = ($id('sim_pos')||{}).value || 'upright';
    var tire  = ($id('sim_tire')||{}).value || 'slick';
    var wind  = toNum(($id('sim_wind')||{}).value, 0);

    var CdA_map = {upright:0.60, drops:0.40, cargo:0.75};
    var Crr_map = {slick:0.005, hybrid:0.007, knobby:0.010};
    var CdA = CdA_map[pos] || 0.60;
    var Crr = Crr_map[tire] || 0.005;

    var v = speed/3.6, vw = wind/3.6;
    var P_req = powerRequired(v, mass, grade, Crr, CdA, vw);
    var P_av  = mechAvailable(V, I, drive);

    var pass = P_av >= P_req;
    var vmax = Math.round(solveVmax(P_av, mass, grade, Crr, CdA, vw)*3.6);

    var eff_total = ((drive==='mid')?0.88:0.82)*0.97*((drive==='mid')?0.95:1.00);
    var Pel_used  = pass ? Math.min(V*I, P_req/eff_total)
                         : Math.min(V*I, powerRequired(vmax/3.6, mass, grade, Crr, CdA, vw)/eff_total);
    var v_used_kmh= pass ? speed : vmax;
    var wh_per_km = Math.round((Pel_used/Math.max(0.1, v_used_kmh))*10)/10;

    if($id('sim_out_result')) $id('sim_out_result').textContent =
      pass ? ('PASS at '+speed+' km/h on '+grade+'% grade.')
           : ('LIMITED: max sustainable ≈ '+vmax+' km/h on '+grade+'% grade.');
    if($id('sim_out_power'))  $id('sim_out_power').textContent  =
      'Required mech: '+Math.round(P_req)+' W • Available mech: '+Math.round(P_av)+' W';
    if($id('sim_out_energy')) $id('sim_out_energy').textContent =
      'Estimated draw ≈ '+wh_per_km+' Wh/km at this speed.';
    if($id('sim_out_notes'))  $id('sim_out_notes').textContent  =
      (P_av/P_req<1.15 && pass ? 'Headroom is thin—watch temps. ' : '') +
      (P_av < Pcont*0.9 ? 'Controller-limited below motor continuous. ' : '') +
      ((toNum(($id('sim_v')||{}).value,48))>=72 ? '72V: off-road/private; keep street-legal mode. ' : '') +
      (grade>=8 ? 'Steep: mid-drive + lower gear helps.' : '');
    if($id('sim_results'))     $id('sim_results').style.display='block';
  }

  function copySim(){
    var t = [
      '— Route Verifier —',
      ($id('sim_out_result')||{}).textContent || '',
      ($id('sim_out_power') ||{}).textContent || '',
      ($id('sim_out_energy')||{}).textContent || '',
      'Notes: ' + ( ($id('sim_out_notes')||{}).textContent || '' )
    ].join('\n');
    if(navigator.clipboard && window.isSecureContext){ navigator.clipboard.writeText(t); }
    else { var ta=document.createElement('textarea'); ta.value=t; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); }
    var btn=$id('sim_copy'); if(btn){ var old=btn.textContent; btn.textContent='Copied!'; setTimeout(function(){ btn.textContent=old; },1200); }
  }

  // ---------- ready-safe binder ----------
  function init(){
    var runBtn=$id('sim_run'), cpBtn=$id('sim_copy');
    if(runBtn && !runBtn.__lynx_bound){ runBtn.addEventListener('click', runSim); runBtn.__lynx_bound=true; }
    if(cpBtn  && !cpBtn.__lynx_bound){ cpBtn.addEventListener('click', copySim); cpBtn.__lynx_bound=true; }
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init(); // DOM already ready — bind now
  }
})();